import React, { useEffect } from "react";
import "./ExpIndiv.css";
import Example from "../../components/ui/horizontalScroll/HorizontalScroll.js";
import IntroSection from "../../components/Intro/Intro.jsx";
import ProjectSection from "../../components/Projects/Projects.jsx";
import ExperimentSection from "../../components/Experiments/Experiments.jsx";
import ExperienceSection from "../../components/Experience/Experience.jsx";
import { FollowerPointerCard } from "../../components/ui/FollowingPointer/FollowingPointer.tsx";

import Navbar from "../../components/Navbar/Navbar";

import { useState } from "react";
import { motion, useScroll } from "framer-motion";
import ProjectOutro from "../../components/ProjectOutro/ProjectOutro.jsx";
import Footer from "../../components/Footer/Footer.jsx";
import { TracingBeamDemo } from "../../components/IndivProject/IndivProjectContainer.jsx";
import { useParams } from "react-router-dom";
import { experimentContent } from "../../content/experimentContent.jsx";

const ExpIndivComp = () => {
  const { scrollYProgress } = useScroll();
  const [projObj, setProjObj] = useState({});
  const projId = useParams()["exp-id"];
  useEffect(() => {
    setProjObj(experimentContent.find((item) => item.id === projId));
  });

  useEffect(() => {
    console.log(scrollYProgress);
    console.log("projId", projId);
    console.log("projObj", projObj);
  }, [scrollYProgress]);

  const headTextAppearVar = {
    initial: {
      y: "100%",
      opacity: 0,
      filter: "blur(5px)",
    },
    animate: {
      y: 0,
      opacity: 1,
      filter: "blur(0px)",
      transition: {
        duration: 1,
        ease: "easeInOut",
      },
    },
  };
  return (
    <>
      <motion.div className="base-home-container">
        <>
          <Navbar />
          <motion.svg
            variants={headTextAppearVar}
            animate="animate"
            initial="initial"
            id="progress"
            width="100"
            height="100"
            viewBox="0 0 100 100"
          >
            <circle cx="50" cy="50" r="30" pathLength="1" className="bg" />
            <motion.circle
              cx="50"
              cy="50"
              r="30"
              pathLength="1"
              className="indicator"
              style={{ pathLength: scrollYProgress }}
            />
          </motion.svg>
          <TracingBeamDemo content={projObj} />
          <Footer />
        </>
      </motion.div>
    </>
  );
};

export default ExpIndivComp;
